<div class="docs-view">
  @if (isLoading) {
    <app-spinner message="Caricamento alberatura web in corso..." />
  } @else {
    
    <div class="docs-header">
      <div class="title-section">
        <h1>Web Ingestion</h1>
        <p>{{ subtitle() }}</p>
      </div>
      
      <div class="header-actions">
        <ng-content select="[table-actions]"></ng-content>
      </div>
    </div>

    <div class="table-card">
      <table class="modern-table">
        <thead>
          <tr>
            <th style="width: 100%;">Nome / URL</th>
            <th style="white-space: nowrap; width: 1%;">Tipologia</th>
          </tr>
        </thead>
        <tbody>
          
          @if (currentLevel() !== 'root') {
            <tr class="nav-up-row">
              <td colspan="2" class="p-0">
                <div class="d-flex align-items-center justify-content-between w-100" style="padding: 10px 20px;">
                  
                  <button class="nav-content clickable-back font-bold border-0 bg-transparent" (click)="goBack()">
                    <span class="material-symbols-outlined">subdirectory_arrow_left</span>
                    Torna indietro
                  </button>

                  <div class="breadcrumb-trail d-flex align-items-center gap-2 text-muted fw-normal">
                    <button class="crumb-link d-flex align-items-center border-0 bg-transparent p-0" 
                            (click)="goToRoot()" title="Torna alla radice">
                      <span class="material-symbols-outlined" style="font-size: 1.2rem;">home</span>
                    </button>
                    
                    @for (crumb of breadcrumb(); track crumb.name; let isLast = $last) {
                      <span class="crumb-separator">/</span>
                      <button class="crumb-link border-0 bg-transparent p-0" 
                          [class.crumb-active]="isLast" 
                          [disabled]="isLast"
                          (click)="!isLast && goToBreadcrumb(crumb)">
                        {{ crumb.name }}
                      </button>
                    }
                  </div>
                </div>
              </td>
            </tr>
          }

          @if (hasError) {
            <tr>
              <td colspan="2" class="state-cell error-state">
                <div class="state-content">
                  <span class="material-symbols-outlined icon">error</span>
                  <p>Si è verificato un errore durante il recupero dei siti.</p>
                </div>
              </td>
            </tr>
          } @else if (visibleItems().length === 0) {
            <tr>
              <td colspan="2" class="state-cell empty-state">
                <div class="state-content">
                  <span class="material-symbols-outlined icon">travel_explore</span>
                  <p>Non ci sono dati web da visualizzare.</p>
                </div>
              </td>
            </tr>
          } @else {
            
            @for (item of visibleItems(); track item.id) {
              <tr>
                @if (item.isFolder) {
                  <td class="font-bold clickable-cell p-0">
                    <button class="border-0 bg-transparent w-100 text-start d-flex align-items-center p-3" (click)="goToFolder(item)">
                      <div class="file-name">
                        <span class="material-symbols-outlined folder-icon" 
                              [class.index-icon]="item.type === 'index'"
                              [class.site-icon]="item.type === 'site'">
                          {{ item.type === 'index' ? 'database' : 'language' }}
                        </span>
                        {{ item.name || item.url }}
                      </div>
                    </button>
                  </td>
                  <td>
                    <span class="type-tag folder-tag" [class.index-tag]="item.type === 'index'">
                      {{ item.type === 'index' ? 'Indice' : 'Sito Web' }}
                    </span>
                  </td>
                } 
                @else {
                  <td class="font-bold">
                    <div class="file-name">
                      <span class="material-symbols-outlined file-icon">description</span>
                      {{ item.title || item.url }}
                    </div>
                  </td>
                  <td>
                    <span class="type-tag">Pagina Web</span>
                  </td>
                }
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }
</div>